import React, { useState, useMemo, useEffect } from "react";
import SearchBar from "../Common/SearchBar/main";
import { TriggerStore } from "../../Store";
import { Popup } from "../Common/Popup/main";
import DocumentPopup from "../Popups/documentPopup";
import DeletePopup from "../Popups/deletePopup";
import { useTenants } from "../../hook/useTenents";
import TenantList from "./list";
import TenantForm from "../Popups/tenantsPopup";
import Pagination from "../Pagination/main";
import toast from "react-hot-toast";
import { FaSpinner } from "react-icons/fa";
import Dropdown from "../Common/Dropdown/main";

type Document = {
  type: string;
  name: string;
  url: string;
};
type TenantForEdit = {
  id: number;
  name: string;
  contact: string;
  email: string;
 propertyAddress: any;
  propertyName?:string;
  dueDate: string;
  occupiedDate: string;
  vacatedDate: string;
  rentStatus: "PAID" | "UNPAID";
  depositAmount: number;
  openingBalance: number | null;
  rent: number;
  occupation: string;
  documentUrl: string | null;
  comments: string | null;
  tenantImageUrl: string | null;
  active: boolean;
};
// const EditAndDeleteButton: React.FC<{
//   onEdit: () => void;
//   onDelete: () => void;
// }> = ({ onEdit, onDelete }) => {
//   return (
//     <div className="flex space-x-2">
//       <button className="btn btn-secondary" onClick={onEdit}>
//         <MdEdit className="h-5 w-5 hover:text-primary" />
//       </button>
//       <button className="btn btn-danger" onClick={onDelete}>
//         <MdDelete className="h-5 w-5 hover:text-red-500" />
//       </button>
//     </div>
//   );
// };

const TenantsCard: React.FC = () => {
  const { _Tenants, addTenant, deleteTenant, updateTenant, queryClient } =
    useTenants();
    
  const [isActive, setIsActive] = useState<boolean>(true);
   const [isDelete, setIsDelete] = useState<boolean>(false);
  const { sidebarAction, sidebartrigger } = TriggerStore((state) => state);
  // const { tenants, addTenant, deleteTenant, editTenant } = TenantsStore(
  //   (state) => state
  // );
  const [isEditMode, setIsEditMode] = useState(false);
  const [activeTenantID, setActiveTenantID] = useState<string | null>(null);

  // const handleEdit = (tenant: Tenant, tenantID: string) => {
  //   setActiveTenantID(tenantID);
  //   setIsEditMode(true);
  // };

  const handleDelete = async () => {
    try {
      await deleteTenant.mutateAsync(activeTenantID as any).then(() => {
        setDeletPopup(false);
        toast.success("deleted sucessfullty:)");
      });
    } catch (error) {
      console.log(error);
      toast.error(error as any);
    }
  };
  const [openPopup, setOpenPopup] = useState(false);
  const [documentPopup, setDocumentPopup] = useState(false);
  const [DeletPopup, setDeletPopup] = useState(false);
  const [activeId, setActiveId] = useState("");
  const [documents, setDocument] = useState<Document[]>();
  //const [isActive, setIsActive] = useState("Active");
  const [addPropertyStatus, setAddProperty] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedTenants, setSelectedTenants] = useState<TenantForEdit | null>(null);

  // Sample data for demonstration
  const sampleData = Array.from({ length: 100 }, (_, index) => ({
    id: index + 1,
    name: `Item ${index + 1}`,
    description: `This is the description for item ${index + 1}`,
  }));

  // State for pagination
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(250);
 const [statusDropdownOpen, setStatusDropdownOpen] = useState(false);
  const data = _Tenants({ active: isActive, delete: isDelete, page: currentPage, size: itemsPerPage });

  const { commercialTenants, residentialTenants } = useMemo(() => {
  
    if (data?.isSuccess && data.data?.data) {

      // Filter commercial properties
      const commercialTenants = data.data.data.commercialTenants.filter((tenant) =>
        tenant.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
  
      // Filter residential properties
      const residentialTenants = data.data.data.residentialTenants.filter((tenant) =>
        tenant.name.toLowerCase().includes(searchQuery.toLowerCase())
      
      );
  
       //  console.log("tenant data 109", commercialTenants  );
    // console.log("tenant data 109 res", residentialTenants  );
      return {
        commercialTenants,
        residentialTenants,
      };
     
    }
  
    // Return empty arrays if no data is available
    return {
      commercialProperties: [],
      residentialProperties: [],
    };
  }, [data?.data, data?.isSuccess, searchQuery]); // Proper dependencies
  
  useEffect(() => {
    data.refetch();
    
  }, [isActive, isDelete, currentPage, itemsPerPage, data.refetch]);

  
  // Calculate total items and the current items to display
  const totalItems = sampleData.length;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentItems = filteredProperties?.slice(
  //   indexOfFirstItem,
  //   indexOfLastItem
  // );
  // const columns = [
  //   { key: "tenantName", title: "Tenant Name", type: "text" },
  //   { key: "tenantID", title: "Tenant ID", type: "text" },
  //   { key: "phoneNumber", title: "Phone Number", type: "text" },
  //   { key: "propertyName", title: "Property Name", type: "text" },
  //   { key: "occupation", title: "Occupation", type: "text" },
  //   { key: "dueDate", title: "Due Date", type: "date" },
  //   { key: "dateOccupied", title: "Date Occupied", type: "date" },
  //   { key: "depositAmount", title: "Deposit Amount", type: "number" },
  //   { key: "rent", title: "Rent", type: "number" },
  //   { key: "rentStatus", title: "Rent Status", type: "text" },
  //   { key: "documents", title: "Documents", type: "array" },
  //   { key: "actions", title: "Actions", type: "component" },
  // ];

  // const handleEdit = (property: Tenant) => {
  //   setSelectedTenants(property);
  //   setOpenPopup(true);
  // };

  // const handleDelete = () => {
  //   console.log(activeId, "pp");
  //   // deleteTenant(activeId);
  //   setDeletPopup(false);
  // };

  const handleSubmit = async (formData: Tenant) => {
    setSelectedTenants(formData);
   // console.log(formData)
    if (addPropertyStatus) {
      try {
        const TenentData = await addTenant.mutateAsync(formData).then(()=>{
          toast.success("Tenant added successfully!");
          data.refetch()
        });
        // if (TenentData) {
        //   toast.success("Tenant added successfully!");
        //   queryClient.invalidateQueries({ queryKey: ["tenants"] });
        // }
      } catch (error: any) {
        console.log(error,"ppp")
      }
    } else {
      try {
        await updateTenant.mutateAsync({
          id: activeTenantID,
          updatedTenant: formData,
        });
      } catch (error: any) {
        toast.error("error");
      }
    }
    setOpenPopup(false);
    setAddProperty(false);
  };

  const handleCancel = () => {
    setOpenPopup(false);
  };

  return (
    <div className="h-screen flex w-full flex-col">
      {/* Header */}
      <header className="sticky top-0 bg-white shadow z-10">
        <h1 className="text-2xl text-start font-bold px-5 py-2">
          Tenants
        </h1>
        <div className="py-4 px-5 flex flex-col w-full items-center justify-between">
          <div className="flex flex-col sm:flex-row w-full items-center justify-between gap-4">
            {/* <Dropdown
              options={["Active", "Inactive"]}
              className="w-full  sm:w-1/4"
              className2="py-2"
              onSelect={(e) => setIsActive(e)}
              activeOption={isActive}
            /> */}
             {/* Updated Dropdown for Active/Inactive */}
             <div onClick={() => setStatusDropdownOpen(!statusDropdownOpen)}>
              <Dropdown
                options={["Active", "Inactive","Deleted"]}
                className="w-full sm:w-60"
                className2="py-3 text-sm"
                onSelect={(e) => {
                  setIsActive(e === "Active" ? true : false);
                   setIsDelete(e === "Deleted" ? true : false);
                  setStatusDropdownOpen(false); // Close dropdown after selection
                }}
                activeOption={isActive ? "Active" : "Inactive"}
                isOpen={statusDropdownOpen}
                setIsOpen={setStatusDropdownOpen}
                closeOtherDropdown={() => {}}
              />
            </div>
            {/* <div className="w-full sm:w-auto">
              <SearchBar onClear={() =>{
                setSearchQuery("")
              }} onSearch={(query) => setSearchQuery(query)} 
             
              />
            </div> */}
        
{/* <div className="w-full sm:w-auto">
  <SearchBar
    suggestionInputEnable={{
      setActiveValue: (value: string) => {
        setSearchQuery(value);
      },
      activeValue: searchQuery,
      enable: true,
      loading: data.isLoading, 
      onSuggestionSelect: (index: number) => {
        const allTenantNames = [
          ...(data.data?.data?.commercialTenants || []).map((tenant: any) => tenant.name),
          ...(data.data?.data?.residentialTenants || []).map((tenant: any) => tenant.name)
        ];
        
        if (allTenantNames[index]) {
          setSearchQuery(allTenantNames[index]);
        }
      },
      suggestions: data.isSuccess ? [
        ...(data.data?.data.commercialTenants || []).map((tenant: any) => tenant.name),
        ...(data.data?.data.residentialTenants || []).map((tenant: any) => tenant.name)
      ] : [],
    }}
    onClear={() => {
      setSearchQuery("");
    }}
    onSearch={(query) => setSearchQuery(query)}
  />
</div> */}
<div className="w-full sm:w-auto">
  <SearchBar
    suggestionInputEnable={{
      setActiveValue: (value: string) => {
        setSearchQuery(value);
      },
      activeValue: searchQuery,
      enable: true,
      loading: data.isLoading,
      onSuggestionSelect: (index: number) => {
        // First, get all tenant names
        const allTenantNames = [
          ...(data.data?.data?.commercialTenants || []).map((tenant: any) => tenant.name),
          ...(data.data?.data?.residentialTenants || []).map((tenant: any) => tenant.name)
        ];
        
        // Then filter them based on the current search query
        const filteredSuggestions = allTenantNames.filter(name =>
          name.toLowerCase().includes(searchQuery.toLowerCase())
        );
        
        // Use the index from the filtered list
        if (index >= 0 && index < filteredSuggestions.length) {
          setSearchQuery(filteredSuggestions[index]);
        }
      },
      suggestions: data.isSuccess ? [
        ...(data.data?.data.commercialTenants || []).map((tenant: any) => tenant.name),
        ...(data.data?.data.residentialTenants || []).map((tenant: any) => tenant.name)
      ] : [],
    }}
    onClear={() => {
      setSearchQuery("");
    }}
    onSearch={(query) => setSearchQuery(query)}
  />
</div>
            <button
              className="bg-primary flex justify-center gap-1 text-white hover:bg-secondary rounded-lg px-4 py-2 text-sm w-full sm:w-auto"
              onClick={() => {
                setSelectedTenants(null);
                setAddProperty(true);
                setOpenPopup(true);
              }}
            >
              Add{" "}
              <span className="lg:hidden sm:block md:block   xl:block">
                New
              </span>
            </button>
          </div>
        </div>
      </header>

      {/* Scrollable Table */}

      {data.isLoading?  <div className="h-full w-full justify-center flex items-center">
        <p className="flex gap-1 justify-center   text-black items-center">
          <FaSpinner className="animate-spin mr-2" /> Loading...
        </p>
      </div>: <div>
     <div className="min-w-full flex gap-2 flex-col  p-4 ">
          <p className="text-base font-semibold py-1  w-full border-b border-gray-300">Commercial Tenants</p>
          {commercialTenants==undefined|| commercialTenants?.length < 0 ? (
            <p>no data</p>
          ) : (
        
            <TenantList
            loading={data.isLoading}
            setDeletPopup={setDeletPopup}
            setSelectedTenants={setSelectedTenants}
            setOpenPopup={setOpenPopup}
            tenants={commercialTenants as any}
            setActiveTenantID={setActiveTenantID}
            setIsEditMode={setIsEditMode}
          />
          )}
        </div>
      <div className="min-w-full flex flex-col gap-2  p-4 ">
      <p className="text-base font-semibold  py-1  w-full border-b border-gray-300">Residential Tenants</p>
          { residentialTenants==undefined||residentialTenants?.length < 0 ? (
            <p>no data</p>
          ) : (
           
            <TenantList
            loading={data.isLoading}
            setDeletPopup={setDeletPopup}
            setSelectedTenants={setSelectedTenants}
            setOpenPopup={setOpenPopup}
            tenants={residentialTenants as any}
            setActiveTenantID={setActiveTenantID}
            setIsEditMode={setIsEditMode}
          />
          )}
        </div>
     </div>}
      {/* <div className="p-4 h-full md:h-screen">
        <TenantList
          loading={data.isLoading}
          setDeletPopup={setDeletPopup}
          setSelectedTenants={setSelectedTenants}
          setOpenPopup={setOpenPopup}
          tenants={C as any}
          setActiveTenantID={setActiveTenantID}
          setIsEditMode={setIsEditMode}
        />
      </div> */}
      {/* <div className="min-w-full  p-4 ">
          { filteredProperties?.length < 0 ? (
            <p>no data</p>
          ) : (
            <TenantList
            tenants={tenatsData?.data?.content as any}
            setEdit={setIsEditMode}
            setActiveId={setActiveTenantID}
            handleEdit={handleEdit}
            handleDelete={() =>{}}
          />
          
          )}
        </div> */}
      {/* <div className="flex-1 overflow-hidden">
        <div className="min-w-full  p-1 overflow-auto">
       

          <Table
        columns={columns as any}
        data={filteredProperties.map((item) => ({
          ...item,
          documents: (
            <span className="flex justify-center">
              <BsEye
                onClick={() => {
                  setDocument(item.documents);
                  setDocumentPopup(true);
                }}
                className="h-5 w-5 text-gray-500 hover:text-primary hover:h-7 hover:w-7 active:text-secondary cursor-pointer transition-transform transform-gpu hover:scale-110 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
              />
            </span>
          ),
          actions: (
            <EditAndDeleteButton
              onDelete={() => {
                setDeletPopup(true);
                setActiveId(item.tenantID);
              }}
              onEdit={() => handleEdit(item)}
            />
          ),
        }))}
      />
        </div>
      </div> */}
      {openPopup && (
        <Popup
         // className="lg:top-0 md:top-0 md:h-84 h-screen top-0 rounded"
                className="lg:top-5" //adjust the height of popup appear
          closeButton={true}
          onClose={() => setOpenPopup(false)}
        >
          <TenantForm
            isLoading={addTenant.isPending}
            initialData={selectedTenants as any}
            onSubmit={handleSubmit as any}
            onCancel={handleCancel}
            isOpen={openPopup}
            id={selectedTenants?.id as any}
          />
        </Popup>
      )}

      {documentPopup && (
        <DocumentPopup
          documents={documents}
          setDocumentPopup={setDocumentPopup}
        />
      )}

      {DeletPopup && (
        <Popup onClose={() => setDeletPopup(false)}>
          <DeletePopup
            isOpen={DeletPopup}
            onClose={() => setDeletPopup(false)}
            isLoading={deleteTenant.isPending}
            onDelete={() => {
              handleDelete();
            }}
          />
        </Popup>
      )}
      {/* Pagination */}
      {/* <footer
        className={`xl:sticky md:fixed  fixed sm:fixed lg:fixed lg:w-full bottom-0 bg-blue-50 shadow z-10 transition-width duration-300 ${
          sidebarAction ? "w-[calc(100%)]" : "w-full"
        }`}
      >
        {data.isLoading ? null : (
          <div className="flex justify-center space-x-2">
            <Pagination
              data={currentItems as any}
              ExportFunction={false} 
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              totalItems={totalItems as any}
              onPageChange={setCurrentPage}
              onPageSizeChange={setItemsPerPage}
            />
          </div>
        )}
      </footer> */}
    </div>
  );
};

export default TenantsCard;
